import type { ISignUpTokenDto, ISignUpTokenResponse } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<ISignUpTokenResponse>,
  IPathBaseParam,
  ISignUpTokenDto
>("auth.signUpToken");

export const signUpToken = {
  ...postApis,
};
